/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Type1Arrival } from './type1Arrival';
import { Type1OperationStatus } from './type1OperationStatus';
import { Type1OriginalClassesBeforeUpgrade } from './type1OriginalClassesBeforeUpgrade';
import { Type1UpgradeWaitlisted } from './type1UpgradeWaitlisted';
import { Type1FareInfos } from './type1FareInfos';
import { Type1Meal } from './type1Meal';
import { Type1FlightServices } from './type1FlightServices';
import { Type1StopsInner } from './type1StopsInner';
import { Type1Departure } from './type1Departure';

/**
 * 旅程中のセグメント情報
 */
export interface Type1 {
  /**
   * セグメントID
   */
  id?: string;
  /**
   * キャビンクラス<br/> eco：Economy<br/> ecoPremium：Premium Economy<br/> business：Business<br/> first：First<br/> ※ 空席照会系の場合には返却しない<br/> ※ ただし、キャビンクラスがプレミアムエコノミーの場合、以下に従い表示する。<br/> 1. 国際線である、かつNHグループ販売便またはNHグループ運航便である場合、\"ecoPremium\"<br/> 2. 上記以外の場合、\"eco\"
   */
  cabin?: string;
  /**
   * ブッキングクラス<br/> ※ 空席照会系の場合には返却しない
   */
  bookingClass?: string;
  /**
   * セグメントステータス<br/> ※ 空席照会系の場合には返却しない
   */
  statusCode?: string;
  /**
   * ステータス区分(いずれの区分も、設定ファイルにセグメントステータスを定義する)<br/> confirmed：確定済み<br/> waitlisted：空席待ち<br/> neededCallCenterHandling：コールセンター要確認ステータス<br/> scheduleChanged：スケジュールチェンジ発生<br/> other：上記以外<br/>
   */
  statusType?: Type1.StatusTypeEnum;
  /**
   * バウンドの1便目の出発日と当該セグメントの出発日の年月日単位の日数差<br/> ※それぞれの出発日に遅延/早発が生じている場合は、それぞれ最新出発予定時刻（ETD）を基準に計算する<br/> ※OPEN便の場合は返却しない。
   */
  departureDaysDifferenceByBound?: number;
  /**
   * 当該セグメントの出発日と到着日の年月日単位の日数差<br/> ※OPEN便の場合は返却しない。
   */
  arrivalDaysDifferenceByFlight?: number;
  /**
   * 乗継時間(秒) 次のフライトまでの待機時間<br/> ※出発時刻ないしは到着時刻に遅延/早発が生じている場合は、それぞれ最新出発予定時刻（ETD）、最新到着予定時刻（ETA）を基準に計算する。<br/> ※ただし、次のフライトが存在しない場合には返却しない<br/> ※OPEN便の場合は返却しない。
   */
  connectionTime?: number;
  /**
   * 当該セグメントでマルチエアポート空港間の移動が発生するかどうか<br/> 当該セグメントの到着空港と、同一バウンド内の次のセグメントの出発空港が、マルチエアポートの異なる空港である場合に、trueを返却する
   */
  isMultiAirportConnection?: boolean;
  /**
   * 出発済みかどうか。クーポン情報が出発済みであるか、現在時刻が到着時刻+設定ファイルにて管理される搭乗済みみなし時間を過ぎている場合にtrue
   */
  isFlown?: boolean;
  /**
   * 搭乗済みであるかどうか<br/> 以下のいずれかに合致する場合にtrueとする。<br/> 1.クーポン情報が出発済みである。<br/> 2.クーポン情報が未使用でない、かつ現在時刻が到着時刻 + 搭乗済みみなし時間を過ぎている。<br/> ※未使用のクーポンステータス、搭乗済みみなし時間は設定ファイルに定義する。
   */
  isOnboarded?: boolean;
  operationStatus?: Type1OperationStatus;
  /**
   * 販売キャリアコード
   */
  marketingAirlineCode?: string;
  /**
   * 便番号 ※DxAPIから返却された便番号が3桁未満の場合は前0埋めし、3桁の番号で返却する。3桁以上の便番号はそのまま返却する。
   */
  marketingFlightNumber?: string;
  /**
   * 運航キャリアコード<br/> 以下の優先順位で返却する。<br/> 1.DxAPIから返却された運航キャリアコード<br/> 2.DxAPIから返却された運航キャリア名称を元にASWDB(マスタ)より取得した運航キャリアコード<br/> <br/> 上記の結果、運航キャリアコードが特定できずに返却する値がない(空文字となる)場合、本項目は返却しないものとする。
   */
  operatingAirlineCode?: string;
  /**
   * DxAPIから返却された運航キャリア名称   ※DxAPIから運航キャリアコードが返却された場合は、DxAPIから返却されるdictionary情報からキャリアコードに紐づくキャリア名称を返却する。キャリアコードが返却されない場合はセグメント情報として返却されるキャリア名称を返却する
   */
  operatingAirlineName?: string;
  departure?: Type1Departure;
  arrival?: Type1Arrival;
  /**
   * 機種コード
   */
  aircraftCode?: string;
  /**
   * DxAPIから返却された機種名
   */
  aircraftName?: string;
  /**
   * 小型機であるかどうか<br/> 下記の全ての条件に合致する場合にtrueを返却する。<br/> 1　NHグループ運航の国際線または、NHグループ販売キャリアの国内線である<br/> 2　機種コードが設定ファイルに定義された小型機の機種コードと一致すること<br/> ※PNR情報取得時には返却しない。
   */
  isSmallAircraft?: boolean;
  /**
   * 総所要時間(秒)<br/> 出発時刻ないしは到着時刻に遅延/早発が生じている場合は、それぞれ最新出発予定時刻（ETD）、最新到着予定時刻（ETA）を基準に計算する<br/> ※OPEN便の場合は返却しない。
   */
  duration?: number;
  /**
   * 深夜発かどうか。出発時刻が設定ファイルに定義した深夜発時間帯の間であればtrue
   */
  isLateNightDeparture?: boolean;
  /**
   * OPEN便かどうか。<br/> 便番号が\"OPEN\"の場合、true
   */
  isOpenSegment?: boolean;
  /**
   * 政府認可申請状況区分<br/> ASWDB(マスタ)より、販売キャリアコードと便番号を元に、政府認可申請対象期間および、対象曜日であるかを判定し、認可申請中の場合にtrue
   */
  isSubjectToGovernmentApproval?: boolean;
  /**
   * 途中寄港地点情報
   */
  stops?: Array<Type1StopsInner>;
  /**
   * ACV ※NHグループ運航便の場合に返却する
   */
  aircraftConfigurationVersion?: string;
  flightServices?: Type1FlightServices;
  meal?: Type1Meal;
  /**
   * スケジュールチェンジが発生しているか<br/> スケジュールチェンジ区分がある場合true
   */
  isScheduleChanged?: boolean;
  /**
   * スケジュールチェンジ区分<br/> waitlistedTimeChanged：マイナースケジュールチェンジ(空席待ち)。ステータスがTL、かつ対応するUNセグメントが存在しない<br/> waitlistedFlightChanged：メジャースケジュールチェンジ(空席待ち)。ステータスがTL、かつ対応するUNセグメントが存在する<br/> upgradeWaitlistedTimeChanged：マイナースケジュールチェンジ(アップグレード空席待ち)。ステータスがTL、かつ対応するUNセグメントが存在せずアップグレード空席待ち<br/> upgradeWaitlistedFlightChanged：メジャースケジュールチェンジ(アップグレード空席待ち)。ステータスがTL、かつ対応するUNセグメントが存在し、アップグレード空席待ち<br/> timeChanged：マイナースケジュールチェンジ。ステータスがTK、かつ対応するUNセグメントが存在しない<br/> flightChanged：メジャースケジュールチェンジ。以下のいずれかに該当する<br/> 1.ステータスがTK、かつ対応するUNセグメントが存在する<br/> 2.PNRチャネル区分がnh、ndc以外、かつ当該セグメントが含まれるバウンドについてDxAPIよりイレギュラーが起こっている旨が返却されている<br/> 3.PNRチャネル区分がnh、ndc以外、かつ当該セグメントが含まれるバウンドのAck/Self Reaccの利用不可理由が、イレギュラーが発生しているとみなさない不可理由(設定ファイルに定義)ではない。(※DxAPIから返却されたエラーコードにて判定する)
   */
  scheduleChangeType?: Type1.ScheduleChangeTypeEnum;
  /**
   * アップグレードしているか<br/> アップグレード区分がある場合true
   */
  isUpgraded?: boolean;
  /**
   * アップグレード区分<br/> plusgrade：BidMyPrice。以下の条件を全て満たす場合。<br/> 1.当該セグメントにリレートするSSR BIDPが存在する<br/> 2.当該セグメントが日本発着国際線、かつNH運航<br/> positive：ポジティブアップグレード。当該セグメントにリレートするSK PUPGが存在する場合。<br/> doubleUpgradePointRequest：2倍ポイントアップグレードリクエスト。NHグループ運航国際線で、当該セグメントにリレートする2倍ポイントアップグレードSK(設定ファイルにて管理)が存在する場合。<br/> starAllience：STAR。当該セグメントにリレートするSSR STARが存在する場合。<br/> mile：マイル。フリーテキスト部にAMCUを含むSSR FQTUが存在する場合。<br/> upgradePoint：アップグレードポイント。フリーテキスト部にELTUを含むSSR FQTUが存在する場合。<br/> creditCard：クレジットカード支払いによるアップグレード。SSR UPGDが存在する場合。<br/><br/> ※アップグレード空席待ちの場合、「当該セグメント」がアップグレード前のセグメントになってしまうため、アップグレード空席待ちのセグメントを「当該セグメント」として取り扱う。
   */
  upgradeType?: Type1.UpgradeTypeEnum;
  /**
   * DynamicWaiver対象か<br/> 当該セグメントに対してwaiverCodeが返却されていた場合にtrue
   */
  isDynamicWaiverApplicable?: boolean;
  /**
   * スターアライアンス加盟キャリア運航かどうか<br/> ※ASWDB(マスタ)にて運航会社がスターアライアンス加盟キャリアであればtrue
   */
  isStarAllianceOperated?: boolean;
  /**
   * 利用可能なキャビンクラスのリスト<br/> 当該ACVを元に、ASWDB(マスタ)より対象キャビンクラスを取得する<br/> eco：Economy<br/> ecoPremium：Premium Economy<br/> business：Business<br/> first：First<br/> ※NHグループ運航のみ返却\"
   */
  availableCabins?: Array<string>;
  /**
   * NHグループ販売便かどうか<br/> 販売キャリアコードがNH/NQである場合、true
   */
  isNhGroupMarketing?: boolean;
  /**
   * NHグループ運航便かどうか<br/> 運航キャリアコードがNH/NQ/EH運航である場合、true
   */
  isNhGroupOperated?: boolean;
  /**
   * 便種別<br/> nhGroupOperating：NHグループ運航便。NHグループ販売便かどうか、NHグループ運航便かどうかがともにtrue<br/> nhGroupMarketing：NHグループ販売便。NHグループ販売便かどうかがtrue、かつNHグループ運航便かどうかがfalse<br/> otherAirlineMarketing：他社販売便。NHグループ販売便かどうか、NHグループ運航便かどうかがともにfalse
   */
  operatingType?: Type1.OperatingTypeEnum;
  /**
   * キャビンクラス名称の後ろに補足が必要か<br/> 以下の条件をすべて満たす場合にtrue<br/> 1.特典PNR区分がfalse<br/> 2.社員用PNR区分がfalse<br/> 3.当該セグメントの便名がNHである<br/> 4.当該セグメントが日本国内区間でない\"
   */
  isNeededToSupplementBookingClass?: boolean;
  fareInfos?: Type1FareInfos;
  /**
   * アップグレード可能キャビンクラスリスト<br/> 当該セグメントについて、NHグループ運航の場合に、以下の条件を満たすキャビンクラスを、リストとして返却する。<br/> 1.以下のいずれかを満たす<br/> 1-1.国際線の場合、キャリアコード、日本発か否か、ブッキングクラス、搭乗日、操作日を基に、ASWDB(マスタ)の有償ブッキングクラスマスタにて<br/> アップグレード可能なキャビンクラスとして定義されている(アップグレード区分にて判定)。<br/> 1-2.国際旅程に含まれる日本国内区間の場合、キャリアコード、ブッキングクラス、搭乗日、操作日を基に、ASWDB(マスタ)の有償ブッキングクラスマスタにて<br/> アップグレード可能なキャビンクラスとして定義されている(日本国内線アップグレード区分にて判定)。<br/> 1-3.日本国内単独旅程の場合、Fare Family の priority code 毎の国内用アップグレード可否が true（true の場合、first を返却）。<br/> 2.ACVと上記キャビンクラスに紐づく情報がASWDB(マスタ)のキャビンクラス別機材情報テーブルが存在する<br/> ※アップグレードの残席状況は考慮しない可否を返却する。<br/> ※アップグレード不可の場合には、返却しない<br/> ※ 空席照会系の場合には返却しない<br/> ※日本国内単独旅程の場合、アップグレード先は first のみ
   */
  upgradableCabins?: Array<string>;
  /**
   * 48時間以内出発フラグ<br/> 現在時刻が、当該セグメントの出発まで48時間以内である場合、true。
   */
  isDepartedWithin48Hours?: boolean;
  /**
   * 日本国内線であるかどうか<br/> 日本国内線の場合true、国際線の場合falseを返却する
   */
  isJapanDomesticFlight?: boolean;
  upgradeWaitlisted?: Type1UpgradeWaitlisted;
  /**
   * 当該セグメントの最新出発日と最新到着日の年月日単位の日数差
   */
  estimatedArrivalDaysDifferenceByFlight?: number;
  originalClassesBeforeUpgrade?: Type1OriginalClassesBeforeUpgrade;
  /**
   * 24時間以内出発フラグ<br/> 現在時刻が、当該セグメントの出発まで24時間以内である場合、true。
   */
  isDepartedWithin24Hours?: boolean;
  /**
   * 便の出発日が操作日か否か<br/> 便の出発日が操作日の場合、true<br/> ※日本時間で判定<br/> ※日本国内線の場合のみ判定する
   */
  isTodayFlight?: boolean;
  /**
   * チェックイン状態 partiallyCheckedIn：旅客の一部がCKI済み allCheckedIn：全旅客がCKI済み noCheckedIn：全旅客が未CKI
   */
  checkedInStatus?: Type1.CheckedInStatusEnum;
  /**
   * 全BoundのFlightの中で同一搭乗日、同一区間、且つstatusCodeが”HL\"のセグメントが存在するか否か 存在する場合、true ※空港コードが異なっていても同一都市の場合は、同一と見做す
   */
  existsAlternativeWaitlistedSegment?: boolean;
  /**
   * スタンバイチェックインHLか<br/> 以下を全て満たす場合、true<br/> 1.statusCodeがHLである<br/> 2.全BoundのFlightの中で同一搭乗日、かつ同一区間、かつstatusCodeが\"HK\"、かつチェックイン状態がallCheckedInであるセグメントが存在する<br/> ※空港コードが異なっていても、同一都市の場合、同一空港と見做して区間を判定する。
   */
  isStandbyCheckInHL?: boolean;
  /**
   * 空席待ちが終了しているかどうか<br/> 空席待ちが終了している場合、true<br/> ※CPRから取得できるOnload Statusがfinalizedとなっている場合は空席待ち終了と判定する。
   */
  isWaitlistFinalized?: boolean;
}
export namespace Type1 {
  export type StatusTypeEnum = 'confirmed' | 'waitlisted' | 'neededCallCenterHandling' | 'scheduleChanged' | 'other';
  export const StatusTypeEnum = {
    Confirmed: 'confirmed' as StatusTypeEnum,
    Waitlisted: 'waitlisted' as StatusTypeEnum,
    NeededCallCenterHandling: 'neededCallCenterHandling' as StatusTypeEnum,
    ScheduleChanged: 'scheduleChanged' as StatusTypeEnum,
    Other: 'other' as StatusTypeEnum,
  };
  export type ScheduleChangeTypeEnum =
    | 'waitlistedTimeChanged'
    | 'waitlistedFlightChanged'
    | 'upgradeWaitlistedTimeChanged'
    | 'upgradeWaitlistedFlightChanged'
    | 'timeChanged'
    | 'flightChanged';
  export const ScheduleChangeTypeEnum = {
    WaitlistedTimeChanged: 'waitlistedTimeChanged' as ScheduleChangeTypeEnum,
    WaitlistedFlightChanged: 'waitlistedFlightChanged' as ScheduleChangeTypeEnum,
    UpgradeWaitlistedTimeChanged: 'upgradeWaitlistedTimeChanged' as ScheduleChangeTypeEnum,
    UpgradeWaitlistedFlightChanged: 'upgradeWaitlistedFlightChanged' as ScheduleChangeTypeEnum,
    TimeChanged: 'timeChanged' as ScheduleChangeTypeEnum,
    FlightChanged: 'flightChanged' as ScheduleChangeTypeEnum,
  };
  export type UpgradeTypeEnum =
    | 'plusgrade'
    | 'positive'
    | 'doubleUpgradePointRequest'
    | 'starAllience'
    | 'mile'
    | 'upgradePoint'
    | 'creditCard';
  export const UpgradeTypeEnum = {
    Plusgrade: 'plusgrade' as UpgradeTypeEnum,
    Positive: 'positive' as UpgradeTypeEnum,
    DoubleUpgradePointRequest: 'doubleUpgradePointRequest' as UpgradeTypeEnum,
    StarAllience: 'starAllience' as UpgradeTypeEnum,
    Mile: 'mile' as UpgradeTypeEnum,
    UpgradePoint: 'upgradePoint' as UpgradeTypeEnum,
    CreditCard: 'creditCard' as UpgradeTypeEnum,
  };
  export type OperatingTypeEnum = 'nhGroupOperating' | 'nhGroupMarketing' | 'otherAirlineMarketing';
  export const OperatingTypeEnum = {
    NhGroupOperating: 'nhGroupOperating' as OperatingTypeEnum,
    NhGroupMarketing: 'nhGroupMarketing' as OperatingTypeEnum,
    OtherAirlineMarketing: 'otherAirlineMarketing' as OperatingTypeEnum,
  };
  export type CheckedInStatusEnum = 'partiallyCheckedIn' | 'allCheckedIn' | 'noCheckedIn';
  export const CheckedInStatusEnum = {
    PartiallyCheckedIn: 'partiallyCheckedIn' as CheckedInStatusEnum,
    AllCheckedIn: 'allCheckedIn' as CheckedInStatusEnum,
    NoCheckedIn: 'noCheckedIn' as CheckedInStatusEnum,
  };
}
